import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { log } from '../utils';

export function Login() {
    const { login } = useAuth();
    const emailRef = useRef();
    const passwordRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState('');

    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    const [open, setOpen] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading('disabled');
            await login(emailRef.current.value, passwordRef.current.value);
            setSuccess(true);
            navigate('/');
        } catch (err) {
            if (!err.response) {
                setError('Network Error');
                log('Login Error', 'Network Error');
            } else if (err.response.status === 400) {
                setError('Invalid Credentials');
                log('Login Error', 'Invalid Credentials');
            } else if (err.response.status === 401) {
                setError('Unauthorized');
                log('Login Error', 'Unauthorized');
            } else {
                setError('Failed to login. Please try again later.');
                log('Login Error', 'Failed to login. Please try again later.');
            }
        }

        setLoading('');
    }

    useEffect(() => {
        if (success) {
            navigate('/');
        }
    }, [navigate, success]);

    return (
        <>
            <div className="bc--card">
                <div className="bc--card-title">Welcome Back!</div>
                {success}
                <div className="bc--card-form">
                    <form id="login_user" onSubmit={handleSubmit}>
                        <div className="input-block">
                            <input
                                type="email"
                                ref={emailRef}
                                name="username"
                                id="username_input"
                                required
                                spellCheck="false"
                            />
                            <label className="placeholder" htmlFor="username_input">
                                Email Address *
                            </label>
                        </div>
                        <div className="input-block">
                            <input
                                type="password"
                                ref={passwordRef}
                                name="password"
                                id="password_input"
                                required
                                spellCheck="false"
                            />
                            <label className="placeholder" htmlFor="password_input">
                                Password *
                            </label>
                        </div>
                        <div className="input-block">
                            <button
                                disable={loading}
                                type="submit"
                                className="btn btn-block btn-primary"
                                id="submit_button"
                            >
                                Login
                            </button>
                        </div>
                    </form>
                    <div className="subtext">
                        <Link to="/forgot" color="persiangreen">
                            Forgot Password
                        </Link>
                    </div>
                </div>
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
        </>
    );
}